import EventActionProto from '../event-action-proto';
import SessionLoader from "core/gd/data/session-loader";
// import {ITEM_VIEW_TASK} from "core/gd/app-manager/item-view";

export default class SessionTaskNew extends EventActionProto {

    constructor(sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
        this.method     = sessionEvent.method
        this.header     = {
            task        : sessionEvent.task,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        /*const taskView = gd.itemView.findByContainerId(ITEM_VIEW_TASK);

        // do not process event for user who initiated add
        // do not ignore if taskView is open
        if (this.fromSID === gd.sessionId && !taskView) {
            // console.log("same user -> ignore");
            return false;
        }*/

        if (this.isDifferentCompany()) return false;

        // console.log("SessionTaskNew process", this);

        let sessionLoader = new SessionLoader();

        sessionLoader.process(gd.session.findMissing({
            statuses: [this.data.taskStatusId],
        }));

        sessionLoader.done(()=>{
            gd.modelBus.newUpdate('task', this.method, this.header.task.id, this.data, this.header);
        });
    }
};
